/* eslint-disable max-len */
// Node Module Imports
import React from 'react'

import { graphql, useStaticQuery } from 'gatsby'
import styled from 'styled-components'

// Style Imports
import { above, colors } from '../../../../style/design-system'
// Utility Imports
import sortPrograms from '../../../../utils/sortPrograms'
import ChevronBackgroundTwoTone from '../../../elements/ChevronBackgroundTwoTone'
import Footnote from '../../../elements/Footnote'
import Chevron from '../../../uma-svgs/Chevron'

const WhatToLookFor = ({ className }) => {
  const query = useStaticQuery(graphql`
    {
      onlineDegreePrograms: allWpUmaprogram(
        filter: { metaProgramCampus: { eq: "45" }, metaProgramType: { eq: "degree" } }
      ) {
        edges {
          node {
            metaProgramFullName
          }
        }
      }
    }
  `)

  const sortedOnlineDegreePrograms = sortPrograms(query.onlineDegreePrograms.edges)

  return (
    <div className={className}>
      <ChevronBackgroundTwoTone chevron={{ display: false }}>
        <div className="container container--sm text-center">
          <div className="h2 white">FAQs</div>
          <h3 className="h3 white mt-10 mb-8">Why earn a degree in an allied healthcare field?</h3>
          <Chevron className="mb-8" color={colors.dev.green.e()} direction="south" />
          <p className="white">
            Occupations in allied healthcare fields can have a number of requirements before a candidate is considered
            for a role. Though some positions can include on-the-job training, others may require completion from a
            four-year college program, certification, training, or some level of education in the field. Degrees in
            healthcare can show that a candidate already has a certain level of background knowledge and education
            needed for landing a position. Associate degrees in healthcare can provide the technical training, general
            education, and soft skills sometimes expected in jobs in health information management, medical billing and
            coding, healthcare accounting, and more.
          </p>
          <h3 className="h3 white mt-10 mb-8">What degrees in allied healthcare can you get online?</h3>
          <Chevron className="mb-8" color={colors.dev.green.e()} direction="south" />
          <p className="white">
            Each school is different, and as health informatics multiply and diversify, so do the degrees available to
            prospective students. We encourage you to do your research. Below is the list of online degree programs
            offered at Ultimate Medical Academy:
            <Footnote content={'{{"shortcode": "footnote", "content": "${footnoteLanguage.flexibleSchedule}"}}'} />
          </p>
          <div className="list-wrapper list-style-ascii-chevron">
            <ul className="list text-white text-md-left pl-md-9 mb-0">
              {sortedOnlineDegreePrograms
                .filter(
                  ({ node }) =>
                    node.metaProgramFullName !== 'Health Sciences — Medical Office and Billing Specialist' &&
                    node.metaProgramFullName !== 'Health Information Technology',
                )
                .map(({ node }) => (
                  <li key={node.metaProgramFullName}>{node.metaProgramFullName}</li>
                ))}
            </ul>
            <ul className="text-white text-md-left pl-md-9">
              <li>
                Health Sciences — Medical Office
                <br />
                and Billing Specialist
              </li>
            </ul>
          </div>
          <h3 className="h3 white mt-10 mb-8">Is a degree online credible?</h3>
          <Chevron className="mb-8" color={colors.dev.green.e()} direction="south" />
          <p className="white">
            UMA is committed to not only educating its students but preparing them to pursue entry-level jobs as allied
            healthcare professionals.
          </p>
        </div>
      </ChevronBackgroundTwoTone>
    </div>
  )
}

export default styled(WhatToLookFor)`
  .list {
    ${above.md`
      column-count: 2;
    `}
  }
`
